import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentSection: number;
  totalSections: number;
}
export function ProgressBar({
  currentSection,
  totalSections
}: ProgressBarProps) {
  const progress = currentSection / totalSections * 100;
  return <div className="sticky top-3 z-10 bg-white/10 backdrop-blur-md p-4 rounded-2xl mb-6 shadow-sm border border-white/20" data-id="element-19">
      <div className="flex justify-between items-center mb-2" data-id="element-20">
        <span className="text-sm font-medium text-blanco-perla" data-id="element-21">
          Sección {currentSection} de {totalSections}
        </span>
        <span className="text-sm font-medium text-dorado" data-id="element-22">
          {Math.round(progress)}%
        </span>
      </div>
      <div className="h-2 w-full bg-azul-profundo/50 rounded-full overflow-hidden" data-id="element-23">
        <motion.div className="h-full bg-dorado rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-24" />
      </div>
    </div>;
}